import { Component } from '@angular/core';
import { DataTableEvent } from '../../components/data-table/data-table.component';
import { Router } from '@angular/router';
import { PackageService } from '@services/packages/package.service';

@Component({
    selector: 'app-chats',
    templateUrl: './chats.component.html',
    styleUrls: ['./chats.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class ChatsComponent {
  public columns = [{ prop: 'title' }];
  public params = { 'chatConfig.instanceArn': { $exists: true } };

  constructor(public packageService: PackageService, private router: Router) {
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['chats', event.row._id]);
  }
}
